import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleMouthBouche11 = customSolarIconWrapper(<g transform="translate(94 154.5)">
	<path d="M5.50049 14.6431C19.5005 3.97643 33.1672 2.6431 46.5005 10.6431" stroke="#202020" strokeWidth="11" strokeLinecap="round" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleMouthBouche11;
